import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import qs from 'query-string';
import { withRouter } from 'react-router';
import _get from 'lodash/get';

// UI
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Button from '@material-ui/core/Button';
import SearchIcon from '@material-ui/icons/Search';

// Style
import withStyles from '@material-ui/core/styles/withStyles';

const styles = theme => {
  return {
    root: {
      display: 'flex',
      alignItems: 'center',
    },
    form: { width: '315px' },
    row: {
      position: 'relative',
    },
    inputRoot: {
      alignItems: 'center',
    },
    inputAdornment: {
      display: 'flex',
      alignItems: 'center',
    },
    searchButton: {
      marginLeft: theme.spacing(1),
      alignSelf: 'flex-end',
    },
    clearButton: {
      marginLeft: theme.spacing(1),
      alignSelf: 'flex-end',
    },
  };
};

// Component
class ClearableSearchField extends PureComponent {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    onSearch: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired,
    placeholder: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
  };

  state = {
    textFieldValue: '',
  };

  componentDidMount() {
    this.updateSearch();
  }

  componentDidUpdate(_, prevState) {
    if (prevState.textFieldValue === this.state.textFieldValue) {
      this.updateSearch();
    }
  }

  updateSearch = () => {
    const { history } = this.props;
    const query = qs.parse(history.location.search);
    const searchQuery = _get(query, 'q', '');

    if (this.state.textFieldValue !== searchQuery) {
      this.setState({
        textFieldValue: searchQuery,
      });
    }
  };

  handleOnChange = e => {
    this.setState({
      textFieldValue: e.target.value,
    });
  };

  handleOnSearch = () => {
    this.props.onSearch(this.state.textFieldValue);
  };

  handleOnEnter = e => {
    if (e.key === 'Enter') {
      this.handleOnSearch();
    }
  };

  handleClear = () => {
    this.setState({
      textFieldValue: '',
    });
    this.props.onClear();
  };

  render() {
    const { classes, onClear, placeholder } = this.props;
    const { textFieldValue } = this.state;

    // Only displays clear button if there's a query
    const clearButton = textFieldValue && (
      <Button className={classes.clearButton} onClick={onClear}>
        Clear
      </Button>
    );

    return (
      <div className={classes.root}>
        <div className={classes.row}>
          <TextField
            value={textFieldValue}
            className={classes.form}
            onChange={this.handleOnChange}
            onKeyPress={this.handleOnEnter}
            placeholder={placeholder}
            InputProps={{
              classes: {
                root: classes.inputRoot,
              },
              'aria-label': 'search-input',
              startAdornment: (
                <InputAdornment position="start" className={classes.inputAdornment}>
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            name={placeholder}
            data-cy="clearable-search--search-input"
          />
        </div>
        <Button
          className={classes.searchButton}
          onClick={this.handleOnSearch}
          data-cy="clearable-search--search-button"
        >
          Search
        </Button>
        {clearButton}
      </div>
    );
  }
}

export default withRouter(withStyles(styles)(ClearableSearchField));
